function formatDate(date){
  const pad = (n) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ` +
         `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export class Page {
    static open(name) {
        const page = document.getElementById("page-"+name);
        page && page.classList.remove('hidden-hard');
    }

    static close(name) {
        const page = document.getElementById("page-"+name);
        page && page.classList.add('hidden-hard');
    }
    static closeAll(){
        const pages = document.querySelectorAll('[id^="page-"]');
        pages.forEach((page) => page.classList.add('hidden-hard'));
    }

    //success, info, warning, error
    static showAlert(message, type = "info", duration = 3000) {
        const alertBox = document.getElementById("top-alert");
        const alertMessage = document.getElementById("top-alert-message");
        const progressBar = document.getElementById("top-alert-progress");

        if (!alertBox || !alertMessage || !progressBar) return;

        alertMessage.textContent = message;

        // Reset třídy typů
        alertBox.className = "top-alert"; 
        alertBox.classList.add(type); 
        alertBox.classList.remove("hidden-hard");

        // Restartuj progress bar
        progressBar.style.animation = "none";
        progressBar.offsetHeight;
        progressBar.style.animation = `progressBar ${duration}ms linear forwards`;

        setTimeout(() => {
            alertBox.classList.add("hidden-hard");
        }, duration);
    }
}

export class PluginInfo {
  static get version() {
    if (typeof __PLUGIN_VERSION__ !== "undefined") {
        return __PLUGIN_VERSION__;
    }
    return (
        document.querySelector('meta[name="app-version"]')?.content || "0.0.0"
    );
  }
}

export class User{

    static token = null;

    static async login(doAfter) {
        if(await User.loadToken()){
            try {
                typeof doAfter === "function" && doAfter();
            } catch (e) {
                console.error("Po přihlášení došlo k chybě:", e);
            }
            return;
        }

        Page.open("login");
        const submit = document.getElementById("login-submit");

        if (!submit) return;

        const clean = submit.cloneNode(true);
        submit.parentNode.replaceChild(clean, submit);
        const button = document.getElementById("login-submit");

        button.addEventListener("click", async() => {
            Page.open("loading");
            try {
                const success = await this.#logInRecruitis();
                if (success) {
                    Page.close("login");
                    Page.showAlert("Přihlášení proběhlo úspěšně", "success");
                    try {
                        typeof doAfter === "function" && doAfter();
                    } catch (e) {
                        console.error("Po přihlášení došlo k chybě:", e);
                    }
                } else {
                    const username = document.getElementById("login-username")?.value || "";
                    const password = document.getElementById("login-password")?.value || "";

                    if (!username || !password) {
                        Page.showAlert("Prosím, zadejte jméno a heslo", "warning");
                        return false;
                    }
                    Page.showAlert("Email nebo heslo není validní", "error");
                }
            } catch (err) {
                console.error("Login error:", err);
                Page.showAlert("Přihlášení selhalo, zkuste to prosím znovu", "error");
            } finally {
                Page.close("loading");
            }
        });
    }

    static async #logInRecruitis(){
        const username = document.getElementById("login-username")?.value || "";
        const password = document.getElementById("login-password")?.value || "";

        if (!username || !password) {
            Page.showAlert("Prosím, zadejte jméno a heslo", "warning");
            return false;
        }

        const data = await Api.login(username,password);
        if(data && data.payload && data.payload.token){
            this.token = data.payload.token;
            await this.#saveToken();
            return true;
        }
        return false
    }

    static async #saveToken(){
        try {
            Storage.setItem("recruitis_token", this.token);
        } catch (e) {
            console.warn("Failed to persist token:", e);
        }
    }

    static async clearToken(){
        try {
            Storage.removeItem("recruitis_token");
            this.token = null;
        } catch (e) {
            console.warn("Failed to remove token:", e);
        }
    }

    static async loadToken(){
        try{
            if(Storage.existItem("recruitis_token")){
                const token = Storage.getItem("recruitis_token");
                if(token && (await Api.verifyToken(token))){
                    this.token = token;
                    return true
                }
            }
        } catch (e) {
            console.warn("loadToken error:", e);
        }
        return false;
    }

    static async createBottomMenu(candidate){
        // 1) Add candidate to position
        const button = document.getElementById("action-button");
        const menu = document.getElementById("menu");
        const select = document.getElementById("response");

        if (!button || !menu || !select) return;

        let menuOpen = false;

        const jobs = await Api.jobs();
        select.innerHTML = `<option value="" disabled selected>-- Vybrat pozici --</option>`;
        jobs.forEach((job) => {
            const option = document.createElement("option");
            option.value = job.id;
            option.textContent = job.title;
            select.appendChild(option);
        });

        // Povolit tlačítko až při výběru jiné než výchozí možnosti
        select.addEventListener("change", () => {
            button.disabled = !select.value;
        });

        button.addEventListener("click", async () => {
            if (!menuOpen) {
                // Otevře se menu
                menu.classList.remove("hidden");
                button.disabled = true;
                button.textContent = "Přidat k vybrané pozici";
                menuOpen = true;
            } else {
                Page.open("loading");
                try{
                    const value = select.value;
                    if (!value) return;
                    
                    const response = await Api.addCandidateToAnswer(candidate.email,candidate.name.full_name, value);
                    const parsed = await response.json().catch(() => ({}));
                    const message = parsed?.meta?.message || "Hotovo";
                    
                    // Reset
                    select.value = "";
                    button.textContent = "Přidat kandidáta na pozici";
                    menu.classList.add("hidden");
                    menuOpen = false;
                    button.disabled = false;

                    User.createCard() // vyresetovani dat

                    Page.showAlert(message, response.ok ? "success" : "error")
                } catch (e){
                    console.error("addCandidateToAnswer error:", e);
                    Page.showAlert("Akce se nezdařila.", "error");
                } finally {
                    Page.close("loading");
                }
            }
        });
        // 2) Sync mail
        (async () => {
            const syncMenu = document.getElementById("sync-menu");
            const syncSelect = document.getElementById("sync-response");
            const syncBtn = document.getElementById("sync-email-button");

            if (!syncMenu || !syncSelect || !syncBtn) return;

            // load jobs
            try {
                const jobs = candidate.answers; // [{id, title}]
                // reset options
                syncSelect.innerHTML = '<option value="" disabled selected>-- Vyberte pozici --</option>';
                const opt = document.createElement("option");
                opt.value = -1;
                opt.textContent = "Přidat ke kandidátovi bez pozice";
                syncSelect.prepend(opt);
                jobs.forEach(job => {
                    const opt = document.createElement("option");
                    opt.value = job.id;
                    opt.textContent = job.job_title;
                    syncSelect.appendChild(opt);
                });
            } catch (e) {
                console.error("Failed to load jobs for sync:", e);
            }

            let syncMenuOpen = false;
            syncBtn.disabled = false;

            // enable/disable button depending on selection (only when menu is open)
            syncSelect.addEventListener("change", () => {
                if (syncMenuOpen) {
                    syncBtn.disabled = !syncSelect.value;
                }
            });

            syncBtn.addEventListener("click", async () => {
                if (!syncMenuOpen) {
                    // first click → open the select, wait for user choice
                    syncMenu.classList.remove("hidden");
                    syncMenuOpen = true;
                    syncBtn.textContent = "Přidat zprávu k vybrané pozici";
                    syncBtn.disabled = !syncSelect.value;
                    return;
                }

                // second click → perform the sync to the chosen job
                if (!syncSelect.value) {
                    Page.showAlert("Vyberte prosím pozici.", "warning");
                    return;
                }

                document.getElementById("page-loading")?.classList.remove("hidden-hard");
                try {
                    await User.syncCurrentEmail(syncSelect.value);

                    // reset UI
                    syncSelect.value = "";
                    syncMenu.classList.add("hidden");
                    syncMenuOpen = false;
                    syncBtn.textContent = "Synchronizovat zprávu";
                } finally {
                    document.getElementById("page-loading")?.classList.add("hidden-hard");
                }
            });
        })();
        Page.open("bottom-bar");
    }


    static async createUserMenu(){
        const info = document.getElementById("user-info");
        const menu = document.getElementById("logout-menu");

        try{
            const response = await Api.getMe();
            const me = response.payload;

            if (me.avatar) {
                document.getElementById("user-initials").innerHTML = `<img src="${me.avatar}" alt="Avatar" class="avatar-image">`;
            }
            else{
                document.getElementById("user-initials").innerHTML = `<img src="assets/no-avatar.png" alt="Avatar" class="avatar-image">`;
            }
            document.getElementById("user-name").innerText = me.fullname || "Jméno uživatele";
            document.getElementById("user-email").innerText = me.email || "";
        } catch (e) {
            console.warn("getMe failed:", e);
        }

        const verEl = document.querySelector(".plugin-version");
        if (verEl) verEl.textContent = "v" + PluginInfo.version;
        
        if(info && menu){
            info.addEventListener("click", (e) => {
                e.stopPropagation();
                menu.classList.remove("hidden-hard");
            });

            document.addEventListener("click", (e) => {
                if (!info.contains(e.target)) {
                    menu.classList.add("hidden-hard");
                }
            });
        }
        


        const logoutBtn = document.getElementById("logout-button");
        if (logoutBtn) {
            logoutBtn.addEventListener("click", async () => {
                await User.clearToken();
                Page.closeAll();
                User.login(User.createCard);
            });
        }

        Page.open("user-header");
    }

    static async createCard() {

        Page.open("loading");
        await User.createUserMenu();

        const notMyEmail = Mailbox.getCounterpart();
        if (!notMyEmail || !notMyEmail.email) {
            Page.showAlert("V této zprávě nebyl nalezen email kandidáta", "warning");
            Page.close("loading");
            Page.open("empty-selfmail");
            return;
        }
        const response = await Api.getCandidateFromEmail(notMyEmail.email);

        if (!response?.payload || response.payload.length <= 0){
            const createButton = document.getElementById("create-candidate-button");
            if(createButton) {
                createButton.addEventListener("click", async () => {
                    Page.open("loading");
                    try{
                        const result = await Api.rawCall("candidates", "POST", {...notMyEmail, gdpr_agreement: true});
                        if (result.ok) {
                            Page.showAlert("Uchazeč byl úspěšně přidán do databáze.", "success");
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                        } else {
                            console.error("result not ok:", result);
                            Page.showAlert("Při vytváření uchazeče došlo k chybě.", "error");
                        }
                    } catch (e) {
                        console.error("create candidate error:", e);
                        Page.showAlert("Při vytváření došlo k chybě.", "error");
                    } finally {
                        Page.close("loading");
                    }
                });
            }

            Page.open("empty");            
            Page.close("loading");
            return
        }

        const candidate = response.payload[0];

        if (!candidate) {
            document.getElementById("candidate-name").innerText = "Kandidát nenalezen";
            Page.close("loading");
            return;
        }

        User.createBottomMenu(candidate);

        const candidateName = document.getElementById("candidate-full-name");
        if(candidateName) {
            candidateName.innerText = candidate.name.full_name || "";
            candidateName.href = "https://app.recruitis.io/zadavatel/candidate/detail/" + candidate.user_id;
        }
        
        document.getElementById("candidate-name-input").value = candidate.name.full_name || "";
        document.getElementById("candidate-email-input").value = candidate.email || "";
        document.getElementById("candidate-phone-input").value = candidate.phone || "";

        const socialsContainer = document.getElementById("candidate-socials-container");

        if(socialsContainer) {
            socialsContainer.innerHTML = ""; // vyčistit případné staré záznamy
            const socials = candidate.details || [];
            socials.forEach(({ name, value }) => {
                const group = document.createElement("div");
                group.classList.add("input-group");

                const link = document.createElement("a");
                link.href = value;
                link.textContent = name;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                group.appendChild(link);
                socialsContainer.appendChild(group);
            });
        }

        const jobsContainer = document.getElementById("candidate-jobs-container");
        if(jobsContainer) {
            jobsContainer.innerHTML = ""; // Vyčistit předchozí pozice
            (candidate.answers || []).forEach(job => {
                const li = document.createElement("li");
                const link = document.createElement("a");
                link.href = job.url;
                link.target = "_blank";
                link.textContent = job.job_title;
                li.appendChild(link);
                jobsContainer.appendChild(li);
            });
        }
        
        Page.open("candidate");
        Page.close("loading");
    }

    static async syncCurrentEmail(answerId){
        try {
            const counterpart = Mailbox.getCounterpart();
            if (!counterpart?.email) {
                Page.showAlert("V této zprávě nebyl nalezen email kandidáta", "warning");
                return;
            }

            if (!answerId) {
                Page.showAlert("Pozice nebyla vybrána", "warning");
                return;
            }

            const candidateResp = await Api.getCandidateFromEmail(counterpart.email);
            const candidate = candidateResp?.payload?.[0];
            if (!candidate) {
                Page.showAlert("Kandidát nenalezen v Recruitisu.", "warning");
                return;
            }

            const candidateId = candidate.user_id;
            const html = await Mailbox.getHTML();
            const subject = Office.context.mailbox.item.subject;
            const date = formatDate(Office.context.mailbox.item.dateTimeCreated);
            const sentByMe = Mailbox.getCurrentItem().from.emailAddress === Mailbox.getMyEmail();

            // prevent duplicates
            const existing = await Api.getCommunications(candidateId, answerId);
            const exists = (existing?.payload || []).some(c =>
                c.content === html && c.date_of_action === date
            );
            if (exists) {
                Page.showAlert("Zpráva je již synchronizována v Recruitisu.", "info");
                return;
            }

            await Api.sendCommunication(html, subject, candidateId, sentByMe, date, answerId);
            Page.showAlert("Zpráva byla úspěšně synchronizována do Recruitisu.", "success");
        } catch (e){
            console.error("syncCurrentEmail error:", e);
            Page.showAlert("Došlo k chybě při synchronizaci.", "error");
        }
    }
}

export class Mailbox {
    static getCurrentItem() {
        return Office.context.mailbox.item;
    }

    static async getHTML() {
        return new Promise((resolve, reject) => {
            Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, (asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                    resolve(asyncResult.value);
                } else {
                    console.error("Nepodařilo se načíst tělo emailu:", asyncResult.error);
                    reject(asyncResult.error);
                }
            });
        });
    }

    static getMyEmail() {
        return (Office.context.mailbox.userProfile.emailAddress || "").toLowerCase();
    }

    static getCounterpart() {
        const item = this.getCurrentItem();
        const myEmail = this.getMyEmail();

        if (!item) return null;

        if (item.from?.emailAddress?.toLowerCase() === myEmail) {
            const recipients = item.to || [];
            const others = recipients.filter((r) => r.emailAddress.toLowerCase() !== myEmail);
            if (others.length > 0) {
                return {
                    email: others[0].emailAddress,
                    name: others[0].displayName,
                };
            }
        } else if(item.from?.emailAddress) {
            return {
                email: item.from.emailAddress,
                name: item.from.displayName,
            };
        }

        return null;
    }
}

export class Storage {
    static setItem(key, value) {
        localStorage.setItem(key, value);
    }
    static getItem(key) {
        return localStorage.getItem(key);
    }
    static existItem(key){
        return this.getItem(key) !== null;
    }
    static removeItem(key){
        localStorage.removeItem(key);
    }
    static clear(){
        localStorage.clear();
    }

}

export class Api {
    static async rawCall(path, method = "GET", data = {}, token = User.token) {
        const url = new URL("https://app.recruitis.io/api2/" + path);

        const options = {
            method: method.toUpperCase(),
            headers: {
                "Content-Type": "application/json",
                ...(token && String(token).trim() !== "" ? { "Authorization": `Bearer ${token}` } : {})
            },
        };

        if (options.method === "GET") {
            Object.entries(data || {}).forEach(([key, value]) => {
                url.searchParams.append(key, value);
            });
        } else {
            options.body = JSON.stringify(data || {});
        }
        return fetch(url.toString(), options);
    }

    static async call(path, method = "GET", data = {}) {
        const response = await Api.rawCall(path, method, data);
        if (!response.ok) {
            const txt = await response.text().catch(() => "")
            throw new Error(`API ${path} failed: ${response.status} ${txt}`);
        }
        return await response.json();
    }

    static async jobs() {
        try {
            const items = await Api.call("jobs?limit=50");
            return (items.payload || []).map(item => ({
                id: item.job_id,
                title: item.title
            }));
        } catch (e) {
            console.error("jobs() failed:", e);
            return [];
        }
        
    }

    static async verifyToken(token) {
        try {
            const response = await Api.rawCall("me", "GET", {}, token);
            return response.ok;
        } catch (error) {
            console.error("Chyba při ověřování tokenu:", error);
            return false;
        }
    }

    static async login(username, password) {
        const device_name = "chrome-plugin";
        try {
            const response = await Api.call("login", "PUT", {
                username,
                password,
                device_name
            });
            if (response?.payload?.token) return response;

            console.warn("Přihlášení selhalo:", response?.message || "Neznámá chyba");
            return false;

        } catch (error) {
            console.error("Chyba při loginu:", error);
            return false;
        }
    }

    static async getCandidateFromEmail(email) {
        if(!email) return { payload: [] };
        try{
            return await Api.call("candidates/?email=" + encodeURIComponent(email));
        } catch (e) {
            console.error("getCandidateFromEmail failed:", e);
            return { payload: [] };
        }
        
    }

    static async getMe() {
        return await Api.call("me");
    }

    static async sendCommunication(text, subject, id, sentByMe, dateAction, answerId) {
        
        const path = answerId !== "-1" || !answerId
            ? `candidates/${id}/${answerId}/communication`
            : `candidates/${id}/communication`;

        const body = {
            employee_id: id,
            sender_type: sentByMe ? "employee" : "candidate",
            subject: subject,
            content: text,
            direction: sentByMe ? "in" : "out",
            type: "email",
        };

        if (dateAction) {
            body.date_action = dateAction;
        }

        try {
            return await Api.call(path, "POST", body);
        } catch (error) {
            console.error("Chyba při odesílání komunikace:", error);
            return null;
        }
    }

    static async addCandidateToAnswer(candidateEmail,candidateName, answerId){
        return await Api.rawCall(`answers`, "POST", {job_id: answerId,name:candidateName , email: candidateEmail});
    }

    static async getCommunications(candidateId, answerId) {
        const path = answerId !== "-1" || !answerId
            ? `candidates/${candidateId}/${answerId}/communication`
            : `candidates/${candidateId}/communication`;
        return await Api.call(path);
    }
}
